import { BookOpen, GraduationCap, MessagesSquare, Sparkles, Video } from 'lucide-react'
import { FeatureRow, type FeatureItem } from './pro-feature-list'

const WU_FEATURES: FeatureItem[] = [
  {
    icon: <GraduationCap className="size-5" />,
    title: 'Every module, lesson and quiz',
    description: 'A full season of instruction',
  },
  {
    icon: <Video className="size-5" />,
    title: 'Filmed on real hunts',
    description: 'Shot in the field with Show Down Strategies',
  },
  {
    icon: <BookOpen className="size-5" />,
    title: 'Downloadable guides',
    description: 'Reference material for every lesson',
  },
  {
    icon: <MessagesSquare className="size-5" />,
    title: 'Community',
    description: 'Ask questions and swap tactics on the community board',
  },
  {
    icon: <Sparkles className="size-5" />,
    title: 'Includes BlindBook Pro',
    description: 'Every Pro feature at no extra charge',
  },
]

export function ProWuBundle() {
  return (
    <div data-testid="pro-wu-bundle">
      <p className="mb-1 text-xs font-bold uppercase tracking-[0.16em] text-primary">
        Waterfowl U
      </p>
      <p className="mb-4 text-sm text-muted-foreground">
        One subscription covers both — there is no separate BlindBook Pro purchase.
      </p>
      <div className="flex flex-col gap-4">
        {WU_FEATURES.map((feature) => (
          <FeatureRow key={feature.title} feature={feature} />
        ))}
      </div>
    </div>
  )
}
